import type { Transition, Variants } from 'framer-motion';

/* ============================================================
   动画预设 —— Apple / Google 风格
   核心是「弹簧物理」而非线性缓动，让动效有自然的惯性衰减。
   ============================================================ */

// 弹簧过渡：通用、柔和
export const spring: Transition = {
  type: 'spring',
  stiffness: 380,
  damping: 32,
  mass: 0.8,
};

// 较软弹簧：大面板/页面
export const softSpring: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 30,
  mass: 0.9,
};

// 快速弹簧：微交互（按钮、图标）
export const snappySpring: Transition = {
  type: 'spring',
  stiffness: 520,
  damping: 30,
};

// 弹性回弹：强调
export const bouncySpring: Transition = {
  type: 'spring',
  stiffness: 420,
  damping: 22,
  mass: 0.7,
};

/* ---------- 淡入 & 位移 ---------- */
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.28, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, transition: { duration: 0.18 } },
};

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: softSpring },
  exit: { opacity: 0, y: 10, transition: { duration: 0.18 } },
};

/* ---------- 弹窗：缩放 + 淡入 ---------- */
export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.92, y: 8 },
  show: { opacity: 1, scale: 1, y: 0, transition: spring },
  exit: { opacity: 0, scale: 0.96, y: 6, transition: { duration: 0.16, ease: [0.4, 0, 1, 1] } },
};

/* ---------- 桌面下拉菜单 ---------- */
export const dropdown: Variants = {
  hidden: { opacity: 0, scale: 0.94, y: -6 },
  show: { opacity: 1, scale: 1, y: 0, transition: snappySpring },
  exit: { opacity: 0, scale: 0.96, y: -4, transition: { duration: 0.12 } },
};

/* ---------- 移动端底部抽屉 ---------- */
export const sheetUp: Variants = {
  hidden: { y: '100%' },
  show: { y: 0, transition: spring },
  exit: { y: '100%', transition: { duration: 0.24, ease: [0.32, 0, 0.67, 0] } },
};

/* ---------- 遮罩 ---------- */
export const backdrop: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.22 } },
  exit: { opacity: 0, transition: { duration: 0.18 } },
};

/* ---------- 页面切换 ---------- */
export const pageVariants: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { ...softSpring, stiffness: 320 } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.16, ease: [0.4, 0, 1, 1] } },
};

/* ---------- 列表容器 + 子项（交错编排）---------- */
export const listContainer: Variants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.035, delayChildren: 0.02 },
  },
};

export const listItem: Variants = {
  hidden: { opacity: 0, y: 16, scale: 0.98 },
  show: { opacity: 1, y: 0, scale: 1, transition: spring },
  exit: { opacity: 0, scale: 0.98, transition: { duration: 0.12 } },
};

/* ---------- 通知/气泡 ---------- */
export const toastPop: Variants = {
  hidden: { opacity: 0, scale: 0.9, y: 12 },
  show: { opacity: 1, scale: 1, y: 0, transition: bouncySpring },
  exit: { opacity: 0, scale: 0.95, y: 8, transition: { duration: 0.15 } },
};
